"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SuccessCheck = void 0;

var _react = _interopRequireDefault(require("react"));

require("./SuccessCheck.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SuccessCheck = function SuccessCheck(_ref) {
  var className = _ref.className;
  return _react.default.createElement("div", {
    className: "success-checkmark ".concat(className).trim()
  }, _react.default.createElement("div", {
    className: "check-icon"
  }, _react.default.createElement("span", {
    className: "icon-line line-tip"
  }), _react.default.createElement("span", {
    className: "icon-line line-long"
  }), _react.default.createElement("div", {
    className: "icon-circle"
  }), _react.default.createElement("div", {
    className: "icon-fix"
  })));
};

exports.SuccessCheck = SuccessCheck;
var _default = SuccessCheck;
exports.default = _default;